import {
    AddOn,
    CatalogItem,
    CatalogItemObject,
    EquipmentCatalogItem,
    Experience,
    ProductCatalogItem,
    Seller,
    UnitType,
} from "types";
import { getCatalogItemsByUnitType } from "../../../models/Catalog";
import { isChoiceAddOn } from "../../../models/CatalogItem";
import { PreferenceLabels } from "../../../models/DuplicateExperience";
import { omitId, saveData } from "./DuplicateHelper";

interface SaveDemographicsProps {
    catalogItems: CatalogItem[];
    experience: Experience;
    path: string;
}

export const saveDemographics = async ({ catalogItems, experience, path }: SaveDemographicsProps) => {
    const items = [
        ...getCatalogItemsByUnitType(catalogItems, UnitType.DEMOGRAPHIC),
        ...getCatalogItemsByUnitType(catalogItems, UnitType.DEMOGRAPHIC_SECONDARY),
    ];
    const equipmentItems = getCatalogItemsByUnitType<EquipmentCatalogItem>(catalogItems, UnitType.EQUIPMENT);

    await Promise.all(
        items.map(async (item) => {
            const payload = {
                ...omitId<Partial<ProductCatalogItem>>(item),
                object: CatalogItemObject.PRODUCT_CATALOG_ITEM,
                product: { id: experience.id },
            };

            await saveData({ payload, path, item: PreferenceLabels.DEMOGRAPHICS });
        }),
    );

    await Promise.all(
        equipmentItems.map(async (item) => {
            const payload = {
                ...omitId<Partial<EquipmentCatalogItem>>(item),
                object: CatalogItemObject.EQUIPMENT_CATALOG_ITEM,
                product: { id: experience.id },
            };

            await saveData({ payload, path, item: PreferenceLabels.EQUIPMENT });
        }),
    );
};

interface SaveAddonsProps {
    addOns: AddOn[];
    experience: Experience;
    path: string;
    seller: Seller;
}

export const saveAddons = async ({ addOns, experience, path, seller }: SaveAddonsProps) => {
    await Promise.all(
        addOns.map(async (addOn) => {
            const payload: any = {
                object: CatalogItemObject.PRODUCT_CATALOG_ITEM,
                product: { id: experience.id },
                parent: { id: addOn.parent?.id },
                seller: { id: seller.id },
                price: addOn.price,
                overrideParent: addOn.overrideParent,
                sequence: addOn.sequence,
                required: addOn.required,
                visibility: addOn.visibility,
            };

            if (isChoiceAddOn(addOn)) {
                payload.items = addOn.items?.map((item) => {
                    return {
                        id: item.parent?.id,
                        price: item.price,
                        priceType: item.priceType,
                    };
                });
            }

            const item = `${PreferenceLabels.ADDONS}, name: ${addOn.name}`;

            return saveData({ payload, path, item });
        }),
    );
};
